<!-- name: '我要捐-新' -->
<template>
  <div class="donateWrap">
    <a href="http://mp.weixin.qq.com/mp/homepage?__biz=MzUxNjA2MTgxOQ==&hid=8&sn=ecee8778155f8d4d1dcb815a32434953&scene=18#wechat_redirect">
      <div class="banner"></div>
    </a>
    <div class="btnBox clothesBox" @click="
      $router.push({
        path: '/donateSecond',
        query: { title: '我要捐衣物', curSelectTab: '捐衣' },
      })
      ">
      <h3>我要捐衣</h3>
      <p>
        <span>捐赠八成新、无污渍、</span>
        <span>无破损的闲置衣服</span>
      </p>
    </div>
    <div class="btnBox thingBox" @click="
      $router.push({
        path: '/donateSecond',
        query: { title: '我要捐物', curSelectTab: '捐物' },
      })
      ">
      <h3>我要捐物</h3>
      <p>
        <span>捐赠八成新、无污渍、</span>
        <span>无破损的闲置图书</span>
      </p>
    </div>
    <a class="btnBox moneyBox"
      href="https://www.lianquan.org/ContractPlus_ContractInfo?guid=9E0EBD7C6C7912DDD335DBAD6EA3878D66114AE1DE9EA1E2EA228ACC991307C2A8DCE57FAD5C174241EE29A6D90FD7BD"
      target="_blank">
      <h3>我要捐款</h3>
      <p>
        <span>参与每月小额捐或单次捐</span>
        <span>支持宝贝爱蓝天</span>
      </p>
    </a>
    <div class="btnBox myDonateBox" @click="
      $router.push({
        path: '/donateSecond',
        query: { title: '我的捐赠', curSelectTab: '捐衣' },
      })
      ">
      <h3>我的捐赠</h3>
      <p>
        <span>查已捐记录</span>
        <span>选寄出方式与下单快递</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  components: {

  },
  computed: {

  },
  methods: {

  }
}
</script>

<style lang='scss' scoped>
.donateWrap {
  background: url('https://img.bbalt.cn/img_banner_donationnotice.png') no-repeat;
  width: 100%;
  height: 100%;
  background-size: 100% 376px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-content: center;
  padding-top: 240px;
  background-color: #fff;

  .btnBox {
    width: 328px;
    height: 295px;
    margin-bottom: 25px;

    h3 {
      height: 46px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 34px;
      color: #333333;
      line-height: 46px;
      text-align: center;
      font-style: normal;
      margin-top: 15px;
    }

    p {
      margin-top: 4px;
      width: 100%;
      height: 68px;
      font-family: PingFang-SC, PingFang-SC;
      font-weight: 400;
      font-size: 24px;
      color: #666666;
      line-height: 30px;
      text-align: center;
      font-style: normal;

      span {
        display: inline-block;
        width: 100%;
      }
    }

    &.clothesBox {
      background: url('~@/assets/img/bg_clothes.png') no-repeat;
      background-size: 100% 100%
    }

    &.thingBox {
      background: url('~@/assets/img/bg_thing.png') no-repeat;
      background-size: 100% 100%
    }

    &.moneyBox {
      background: url('~@/assets/img/bg_money.png') no-repeat;
      background-size: 100% 100%
    }

    &.myDonateBox {
      background: url('~@/assets/img/bg_myDonate.png') no-repeat;
      background-size: 100% 100%
    }
  }
  .banner {
    position: fixed;
    width: 100%;
    height: 42vw;
    top: 0px;
  }
}
</style>